import React from 'react';

import { GoalsIcon } from '@atlaskit/logo';
import { AppLogo } from '@atlaskit/navigation-system/top-nav-items';
import { useIntl } from 'react-intl';

import { AnalyticsTopNavItem, useSendTopNavItemClick } from '@townsquare/analytics-nav4';

export function ProductHome(): React.JSX.Element {
	const sendTopNavItemClick = useSendTopNavItemClick();
	const intl = useIntl();

	const label = intl.formatMessage({
		id: 'townsquare.goals-app.chrome-navigation.nav-logo-label',
		defaultMessage: 'Home page',
		description:
			'Accessible label for the product logo link in the top left of the navigation which takes users to the product home page',
	});

	return (
		<AppLogo
			icon={GoalsIcon}
			name="Goals"
			href="/goals"
			onClick={() => {
				sendTopNavItemClick(AnalyticsTopNavItem.PRODUCT_LOGO);
			}}
			label={label}
		/>
	);
}
